import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { CommonService } from 'src/app/shared/services/common.service';

@Injectable({
    providedIn: 'root'
})
export class OrderInformationService {

    private apiUrl: string;
    private api_server: string;
    private apiUrl2: string;
    private connectUrl: string;
    private paymentApiUrl: string;

    constructor(private http: HttpClient, public commonService: CommonService
    ) {
        this.apiUrl = environment.apiUrl; /** Saruman URL with webApp */
        this.api_server = environment.api_server; /** Saruman URL without webApp */
        this.apiUrl2 = environment.apiUrl2; /** Figwit URL for razor pay  */
        this.connectUrl = environment.connectUrl; /** Conenct k8 URLs */
        this.paymentApiUrl = environment.paymentApiUrl; /** Saruman URL for New Payment */
    }

    getOrderIdAndRequestType(requestType: any) {
        this.apiUrl = environment.apiUrl;
        if (requestType === "Fwd") {
            this.apiUrl + '/delivery';
        }
        if (requestType === "Rev") {
            this.apiUrl + '/pickup';
        }
        if (requestType === "Fwd") {
            if (this.apiUrl.indexOf('delivery') == -1) {
                this.apiUrl = this.apiUrl + 'delivery';
            }
        }
        if (requestType === "Rev") {
            if (this.apiUrl.indexOf('pickup') == -1) {
                this.apiUrl = this.apiUrl + 'pickup';
            }
        }
        return this.apiUrl;
    }

    getCustomerFeedback(routeData: any) {
        let url = this.getOrderIdAndRequestType(this.commonService.getCookie('request_type')) + `/customer_feedback/${routeData.awb_number}/`;
        return this.http.get(`${url}`)
    }

    verifyPhoneNumber(otpObj: any) {
        let params = {
            contact_number: otpObj.contact_number,
        }
        let url = this.getOrderIdAndRequestType(this.commonService.getCookie('request_type')) + `/otp/${otpObj.awb_number}/`;
        return this.http.post(`${url}`, params);
    }
    resendOTP(otpObj: any) {
        let params = {
            contact_number: otpObj.contact_number
        }
        let url = this.getOrderIdAndRequestType(this.commonService.getCookie('request_type')) + `/otp/${otpObj.awb_number}/`;
        return this.http.post(`${url}`, params);
    }

    getCustomerQueries(routeData: any) {
        let url = this.getOrderIdAndRequestType(this.commonService.getCookie('request_type')) + `/customer_queries/${routeData.awb_number}/`;
        return this.http.get(`${url}`);
    }

    submitRating(obj: any) {
        let params = {
            "customer_feedback": obj.customer_feedback,
            "ratings": obj.ratings,
            "remarks": obj.remarks
        }
        let url = this.getOrderIdAndRequestType(this.commonService.getCookie('request_type')) + `/customer_feedback/${obj.awb_number}/`;
        return this.http.post(`${url}`, params);
    }

    submitAlertAction(obj: any) {
        let params = {
            "awb_number": obj.awb_number,
            "source": "confirmed_webapp",
            "new_status": obj.new_status
        }
        let url = this.getOrderIdAndRequestType(this.commonService.getCookie('request_type')) + `/rto_customer_feedback/`;
        return this.http.post(`${url}`, params);
    }

    getRatingOptions(obj: any) {
        let url = this.api_server + `web_app/delivery/feedback_remarks/?` + `rating=` + obj.rating + `&awb_number=` + obj.awb_number;
        return this.http.get(`${url}`);
    }

    verifyOTP(otpObj: any) {
        let params = {
            otp: otpObj.otp
        }
        let url = this.getOrderIdAndRequestType(this.commonService.getCookie('request_type')) + `/otp/${otpObj.awb_number}/`;
        return this.http.post(`${url}`, params);
    }

    getCustomerLocation(routeData: any) {
        let url = this.api_server + `awb/get_customer_location/${routeData.awb_number}/`;
        return this.http.get(`${url}`);
    }




}
